<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tTe2Zy/tc-custom/9781558618695.jpg?1736601372716" alt="This image is the cover for the book Shipwrecked"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shipwrecked
      </h1>
      <p class="bookDescription body article font2">
        <b>A collection of short stories by Iranian women writers that capture the fear, defiance, and enduring struggle of life under an oppressive regime.</b><br/>  <br/> The 1979 Iranian Revolution was an event that shocked the world. After thousands of years of Persian monarchy, the Iranian people seized power and instituted a strict secular Islamic regime. The revolution sent the despised Shah into exile, put the Ayatollah Khomeini into power, and resulted in the Iran Hostage Crisis.<br/>  <br/> In all the upheaval, little thought was given to the women who, even after helping install the new regime, would have to face a new kind of oppression in their homes and in the public square.<br/>  <br/> Here, the voices of those women are heard. Evoking the enormous isolation of daily existence, and the persistence of a people living under a repressive regime, these literary gems—many by prize-winning authors—reward us with an inside view of a turbulent and closed society.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Fereshteh Nouraie-Simone
      </h2>
      
      <p class="authorDescription body article">Fereshteh Nouraie-Simone is a historian at the American University School of International Service. She teaches courses on gender and social change in the Middle East, Iran, and the history of US-Iran relations.Sara Khalili is a financial journalist, editor, and translator of contemporary Iranian literature. Her published translations include As Red as Fire Tasting of Smoke, Selected Poems of Siavash Kasraii; Lucky those Half-Opened Buds, Selected Poems of Fereydoon Moshiri; several short stories in Strange Times My Dear: A PEN Anthology of Contemporary Iranian Literature; and various short stories by Shahriar Mandanipour. Khalili won a 2007 PEN Translation Fund Grant for her translation from the Farsi of Seasons of Purgatory, a selection of short stories by Iranian writer Shahriar Mandanipour.Faridoun Farrokh is a professor of English at Texas A&M International University. His research interests include contemporary Persian fiction, eighteenth-century English literature, and rhetoric and composition. He has published numerous articles in English and Persian and is the translator of A Mansion in the Sky and Other Stories by Goli Taraghi.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Feminist Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?58b42782